"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_decode_1 = require("jwt-decode");
const isTokenExpired = (token) => {
    if (!token)
        return true;
    try {
        const decoded = (0, jwt_decode_1.jwtDecode)(token);
        const exp = decoded.exp;
        if (!exp)
            return true;
        const expiryDate = new Date(exp * 1000);
        return expiryDate < new Date();
    }
    catch (error) {
        return true;
    }
};
exports.default = isTokenExpired;
